import React from "react";
import menu from "../conf/menu";
import ReportListComponent from "./helper_components/ReportListComponent";
import PaginationComponent from "./helper_components/PaginationComponent";
import CostPhotoListComponent from "./helper_components/CostPhotoListComponent";
import {Modal,Button,Panel,PanelGroup} from "react-bootstrap";
import Switch from 'react-ios-switch';
import filterValue from "../conf/words";
import {Tooltip,OverlayTrigger} from "react-bootstrap";
import CostImagePopup from "./helper_components/CostImagePopup";
import Workbook from 'react-excel-workbook'
import {checkTokenUtil, mapForObject} from "../utils";
import LoadingComponent from "./helper_components/LoadingComponent";
import { getReportingRequest, pdfDownloadReport,setFilter } from "../redux/actions/reports";
import { connectTo, swalOpen } from '../redux/utils';
import { registerField } from "redux-form";
import { SWAL_ERROR_TITLE, SWAL_TYPE_ERROR } from "../utils/constants";
import moment from "moment";

class ReportsComponent extends React.Component{
  constructor(props){
    super(props);
    this.handleBringButtonClick = this.handleBringButtonClick.bind(this);
    this.handleMultiDateChange = this.handleMultiDateChange.bind(this);

    this.state = {
      startPageNumber: 0,
      endPageNumber: 5,
      pageNumberToShow:5,
      activePage:1,
      numberOfPage:10,
      isVisibleModal: false,
      isVisibleModalSumiagro: false,
      costCenterLength:0,
      detail:{
        user:{},
        cost:{}
      },
      multiDate:{
          startDate: null,
          endDate: null
      },
      switchStatus : false,
      transactionModal:false,
      revisionsModal:false,
      img:{
        show:false,
        src:""
      },
        costListsForExcel: 0,
       loading: true,
        costLists:this.props.costLists,
    }
  }

 componentDidMount(){
    const accessToken = this.props.accessToken
    this.props.getReportingRequest({
        accessToken: accessToken,
        employeeId: "-1",
        month: this.refs.month.value,
        year: this.refs.year.value,
        costStatus: this.refs.costStatusOption.value,
        isMultiDate: this.state.switchStatus
    })
}
    componentDidUpdate(prevProps,prevState){
        const result = checkTokenUtil()
        if(prevState.loading !== this.props.loading){
            this.setState({
                loading:this.props.loading
            })
        }
        if(prevState.costLists !==this.props.costLists){
            this.setState({
                costLists: this.props.costLists
            })
        }

    }
  pagination(){
    var {activePage,numberOfPage} = this.state;
    const {costLists} = this.props;
    var pageIndex = (activePage * numberOfPage) - numberOfPage;
    var pageTotal = costLists.length - (activePage * numberOfPage);
    if(pageTotal < 0){
      pageTotal = costLists.length;
    }else{
      pageTotal = pageIndex + numberOfPage;
    }
    return {
      totalPage: Math.ceil(costLists.length / numberOfPage),
      start:pageIndex,
      finish:pageTotal
    }
  }


    async setFilterAction(filterValue){

        if((filterValue.bringButton && this.state.switchStatus)|| !this.state.switchStatus)
        {
            this.setState({
                activePage:1,
                loading:true,
                costLists: []
            })

            await this.props.getReportingRequest({
                accessToken: this.props.accessToken,
                employeeId: filterValue.employee,
                month: filterValue.month,
                year: filterValue.year,
                costStatus: filterValue.status,
                isMultiDate: this.state.switchStatus,
                startDate: this.state.multiDate.startDate,
                endDate: this.state.multiDate.endDate
            })
            await this.props.setFilter(filterValue);
        }


    }
  handleBringButtonClick() {
      const {startDate, endDate} = {...this.state.multiDate}
      let textWarning = "";
      if(startDate && endDate){
          if(endDate > startDate){
            this.setFilterAction({
                status: this.refs.costStatusOption.value,
                employee:this.refs.employees.value,
                bringButton:true
            })
        } else{
            textWarning = this.props.t('startDateAlert')
            swalOpen(SWAL_ERROR_TITLE, textWarning, SWAL_TYPE_ERROR, false);
        }
     } else {
        textWarning = this.props.t('dateRequiredAlert')
        swalOpen(SWAL_ERROR_TITLE, textWarning, SWAL_TYPE_ERROR, false)
     }


  }
  handleMultiDateChange(e) {
    this.setState({
        multiDate:{...this.state.multiDate, [e.target.name] : e.target.value}
    })
 }

     async pdfDownloadButton(costData) {
        let costIds = [];
        const {language} =  this.props.employeeInfo
        let employeeInfo = {
            employeeOID : costData._id,
            employeeID: costData.employeeID,
            employmentID: costData.employmentID,
            employeeName: costData.employeeName,
            pdfLanguage: language,
            unitID:costData.unitID,
            unitLogo: costData.unitLogo,
            unitName: costData.unitName,}
        const accessToken = this.props.accessToken
        if (costData) {
          if (costData.cost) {
            costIds.push(costData.cost.costId)
          }
        }
        await this.props.pdfDownloadReport({employeeInfo, costIds, accessToken});
      }

      async allPdfDownloadButton(){
          let {costLists} = this.state;
          let costIds = [];
          const {language} =  this.props.employeeInfo
          if(costLists && costLists.length> 0){
              for (let i = 0; i < costLists.length; i++) {
                  costIds.push(costLists[i].cost.costId)
              }
          let employeeInfo = {
              employeeOID : costLists[0]._id,
              employeeID: costLists[0].employeeID,
              employmentID: costLists[0].employmentID,
              employeeName: costLists[0].employeeName,
              pdfLanguage: language,
              unitID:costLists[0].unitID,
              unitLogo: costLists[0].unitLogo,
              unitName: costLists[0].unitName,
          }
          const accessToken = this.props.accessToken
          await this.props.pdfDownloadReport({employeeInfo, costIds, accessToken});
        }
      }
  closeAction(){
    this.setState({
      isVisibleModal:false,
      isVisibleModalSumiagro:false
    });
  }
  closeRevisionsModal(){
    const formType = this.state.detail.cost.formType;
    if(formType === "applicationSumiagro" || formType === "settlementSumiagro"){
      this.setState({
        revisionsModal:false,
        isVisibleModalSumiagro:true
      })
    }else{
      this.setState({
        revisionsModal:false,
        isVisibleModal:true
      })
    }
  }
  infoButton(user,cost){
      if(cost.formType === "applicationSumiagro" || cost.formType === "settlementSumiagro"){
        this.setState({isVisibleModalSumiagro:true})
      }else{
        this.setState({isVisibleModal:true})
      }
    this.setState({
      detail:{
        user:user,
        cost:cost
      }
    });
  }
  findApprovedAccountingDate(status, transactions=[]){
    if(status === "completed") {
        let transactionList = transactions.filter(t => t.title === "accounting");
        const lastAccountingApprovalDate = transactionList[transactionList.length-1]?.transactionDate;
        return lastAccountingApprovalDate;
    }
    return null;
  }
  prepareCostDataForExcel(costData){
    if(costData.length > 0){
      var getAllMoney = new window.Money().getAllMoney();
      var getAllMoneyI18nCodes= new window.Money().getAllMoneyI18nCodes()

      var totalAmount = {};
      var data = costData.map((data,index) => {
        totalAmount[data.cost.moneyType] =  !totalAmount[data.cost.moneyType] ? 0 : totalAmount[data.cost.moneyType];
        if(data.cost.moneyType in getAllMoney){
            totalAmount[data.cost.moneyType] += parseFloat(data.cost.costAmount.replace(/,/g, ''));
        }

         
          let costAmount = parseFloat(data.cost.costAmount.replace(/,/g, ''));
          let masrafMatrahi = ((costAmount / (1+parseFloat(data.cost.kdvOrani) / 100))).toFixed(2);
          let kdvTutari = (costAmount - masrafMatrahi);
          const accountingApprovalDate =  this.findApprovedAccountingDate(data.cost.status, data.cost.transactions)
          const empID=data.employeeID;
          let masrafStatusChange = (status) => {
              const {t} = this.props
              if(status === 'manager') return status = t('manager');
              else if(status === 'accounting') return status = t('accounting');
              else if(status === 'accountingCancel') return status =  t("accountingCancel");
              else if(status === 'waiting') return status = t("pending");
              else if(status === 'cancel') return status = t("cancel");
              else if(status === 'completed') return status = t("completed");
          };
          let masrafStatus = masrafStatusChange(data.cost.status)
          // costCenter array object çevriliyor...
          let costCenter = {}
          let costCenterEmptyValue = {}
           data.costCenter.forEach((cost, i) => {
            costCenter["costCenter"+Number(i+1)] = cost
            costCenterEmptyValue["costCenter"+Number(i+1)] = "";
          });
          // costCenterLength state tutuluyor|kontrol ediliyor, böylece kaç kolon yaratıcağımızı buluyoruz
          if(this.state.costCenterLength < data.costCenter.length){
              this.setState({costCenterLength : data.costCenter.length})
          }
          let managerNameAndSurname = ""
          let managerApprovalDate = ""
          if(data.cost.transactions && data.cost.transactions.length > 0 ){
              let {employeeName,transactionDate } = data.cost.transactions.find(t=> t.transactionType === 1) ||[]
              managerNameAndSurname = employeeName
              managerApprovalDate = transactionDate
          }
        return {
          documentNo:index+1,
          employeeId:empID,
          employmentId:data.employmentID,
          employeeName:data.employeeName,
          formType:data.cost.formType === "applicationSumiagro" ? "Application" : "Settlement",
          perSicilNo:data.perSicilNo,
          costDate: moment(data.cost.costDate).format("DD/MM/YYYY"),
          invoiceNo: data.cost.invoiceNo,
          costType: data.cost.costType,
          costAmount: data.cost.costAmount,
          moneyType: data.cost.moneyType,
          exchangeRate: data.cost.exchangeRate,
          paymentType: data.cost.paymentType,
          supplierName: data.cost.supplierName,
          costDescription: data.cost.costDescription,
          accountingApprovalDate,
          ...costCenter,
          costCreatedDate:data.cost.costCreatedDate,
          kdvOrani: data.cost.kdvOrani,
          kdvTutari: kdvTutari,
          masrafMatrahi: masrafMatrahi,
          costCategory:data.cost.costCategory,
          costLocation:data.cost.costLocation,
          costBrand:data.cost.costBrand,
          costStatus:masrafStatus,
          managerNameAndSurname:managerNameAndSurname,
          managerApprovalDate:managerApprovalDate,
          uniqCode : data.costGroupId.slice(-8)
        }
      });
      // ADD EMPTY ROW
      for(var r=0;r<=9;r++)
        data.push({
          documentNo:"",
          employeeName:"",
          costDate: "",
          invoiceNo: "",
          costType: "",
          costAmount: "",
          moneyType: "",
          paymentType: "",
          supplierName: "",
          costDescription: "",
          accountingApprovalDate: "",
          costCreatedDate:"",
        });
      for(var amount in totalAmount){
          data.push({
          documentNo:"",
          employeeName:"",
          costDate: "",
          invoiceNo: "",
          costType: "",
          costAmount: "",
          moneyType: "",
          paymentType: "",
          supplierName: "",
          costDescription: "",
          accountingApprovalDate: "",
          costCreatedDate:this.props.t("totalAmount")+": "+ totalAmount[amount].toLocaleString() +" "+this.props.t(getAllMoneyI18nCodes[amount])
        })
      }
      return data;
    }else{
      return []
    }
  }
  writeCostCenterColumns(){
    let columns = []
    for (let i = 1; i <= this.state.costCenterLength; i++) {
        columns.push(<Workbook.Column label={this.props.t("costCenter")+i} value={"costCenter"+i}/>)
    }
    return columns
  }

  isCostUniqCode(){
      let columns= []
      let {costUniqCode} = this.props.employeeInfo
      if (costUniqCode === 'true'){
          columns.push(<Workbook.Column label={this.props.t("uniqCode")} value={"uniqCode"}/>)
      }
      return columns
  }
    isPublicServant(){
        let columns= []
        let onMasrafSumiagro = this.props.employeeInfo.permission.onMasrafFormuSumiagro
        if(onMasrafSumiagro === "true") {
            {
                columns.push(<Workbook.Column label={this.props.t("costFormType")} value="formType"/> )
            }
        }
        return columns
    }
  prePerInfo(){
      let columns=[]
      columns.push(<Workbook.Column label={this.props.t("employeeID")} value={"employeeID"}/>)
      columns.push(<Workbook.Column label={this.props.t("employmentID")} value={"employmentID"}/>)
      return columns
  }

  costImagePopupShow(src){
    this.setState({
      img:{
        show:true,
        src:src
      }
    })
  }

  switchOnChange(selected) {
    if(!selected)  {
        this.setState({
            multiDate:{
                startDate: null,
                endDate: null
        }})
    }
    this.setState({
        switchStatus: selected
    });
  }

  render(){
    var {employeeList,filter, employeeInfo, t} = this.props;
    document.title = t(menu[this.props.location.pathname])+"- masraf.dakika.com.tr";
    var {costLists} = this.state;
    var year = [];
    for(var i = window.costStartingYear;i<=new Date().getFullYear();i++){
      year.push(<option key={i} value={i}>{i}</option>);
    }
    var {totalPage,start,finish} = this.pagination();
    var {cost,user} = this.state.detail;
    cost.costPhotos = (cost.costPhotos ? cost.costPhotos : []);
    if(!cost.revisions)
      cost.revisions = [];
    var context = this;
    var costListsForExcel = this.prepareCostDataForExcel(costLists);
    let showKdvOrani = costListsForExcel.filter(c => c.kdvOrani && c.kdvOrani.length > 0).length > 0;
    let showAllPdfDownload =
    filter && filter.employee !== "-1"
      ? employeeInfo.permission.accountingPage === "true"
        ? filter.status === "manager" || filter.status === "approved"
        : filter.status === "approved"
      : false;
      let workBookVariable =
          <th>
          <Workbook filename={`${t('reportName')}.xlsx`} element={<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip">{t('export')}</Tooltip>}>
          <button type="button" id="reportPageDownloadButton" className="btn btn-wd btn-success export-btn"><span className="btn-label"><i className="fa fa-file-excel-o" aria-hidden="true"></i></span></button></OverlayTrigger>}>
          <Workbook.Sheet data={costListsForExcel} name="Sheet A">
              {this.isCostUniqCode()}
              <Workbook.Column label={t('employeeID')} value="employeeId"/>
              <Workbook.Column label={t('employmentID')} value="employmentId"/>
              <Workbook.Column label={t('perSicilNo')} value="perSicilNo"/>
              <Workbook.Column label= {t('documentNo')} value="documentNo"/>
              <Workbook.Column label= {t('employee')} value="employeeName"/>
              {this.isPublicServant()}
              <Workbook.Column label= {t('costDate')} value="costDate"/>
              <Workbook.Column label= {t('invoiceNo')} value="invoiceNo"/>
              <Workbook.Column label= {t('costType')} value="costType"/>
              <Workbook.Column label= {t('costAmount')} value="costAmount"/>
              <Workbook.Column label= {t('currencyUnit')} value="moneyType"/>
              <Workbook.Column label= {t('currencyInformation')} value="exchangeRate"/>
              <Workbook.Column label= {t('paymentType')} value="paymentType"/>
              <Workbook.Column label= {t('supplierName')} value="supplierName"/>
              <Workbook.Column label= {t('description')} value="costDescription"/>
              <Workbook.Column label= {t('status')}value="costStatus"/>
              <Workbook.Column label= {t('managerNameAndSurname')}value="managerNameAndSurname"/>
              <Workbook.Column label= {t('managerApprovalDate')}value="managerApprovalDate"/>
              <Workbook.Column label={t('accountingApprovalDate')} value="accountingApprovalDate"/>
              {this.writeCostCenterColumns()}
              <Workbook.Column label= {t('transactionDate')} value="costCreatedDate"/>
          </Workbook.Sheet>
          </Workbook>
              {
                  showAllPdfDownload &&
                  <span>
            &nbsp;
                      <button title={t('downloadAllPDF')} type="button" id={"costListCostDownloadButton-"} onClick={() => { this.allPdfDownloadButton() }} className="btn btn-primary btn-fill btn-wd actionBtn">
              <span className="btn-label"><i className="fa fa-download"></i></span>
            </button>
          </span>

              }
          </th>;

      let workBookWithKdvOrani =
          <th>
          <Workbook filename={`${t('reportName')}.xlsx`} element={<OverlayTrigger placement="bottom" overlay={<Tooltip id="tooltip">{t("export")}</Tooltip>}>
          <button type="button" id="reportPageDownloadButtonKDV" className="btn btn-wd btn-success export-btn"><span className="btn-label"><i className="fa fa-file-excel-o" aria-hidden="true"></i></span></button></OverlayTrigger>}>
          <Workbook.Sheet data={costListsForExcel} name="Sheet A">
              {this.isCostUniqCode()}
              <Workbook.Column label={t('employeeId')} value="employeeId"/>
              <Workbook.Column label={t('employmentId')} value="employmentId"/>
              <Workbook.Column label={t('perSicilNo')} value="perSicilNo"/>
              <Workbook.Column label= {t('documentNo')} value="documentNo"/>
              <Workbook.Column label= {t('employee')} value="employeeName"/>
              {this.isPublicServant()}
              <Workbook.Column label= {t('costDate')} value="costDate"/>
              <Workbook.Column label= {t('invoiceNo')} value="invoiceNo"/>
              <Workbook.Column label= {t('costType')} value="costType"/>
              <Workbook.Column label= {t('costAmount')} value="costAmount"/>
              <Workbook.Column label= {t('currencyUnit')} value="moneyType"/>
              <Workbook.Column label= {t('currencyInformation')} value="exchangeRate"/>
               <Workbook.Column label= {t('paymentType')} value="paymentType"/>
              <Workbook.Column label= {t('vatRate')} value="kdvOrani"/>
              <Workbook.Column label= {t('vatAmount')} value="kdvTutari"/>
              <Workbook.Column label= {t('costTaxBase')} value="masrafMatrahi"/>
              <Workbook.Column label= {t('supplierName')} value="supplierName"/>
              <Workbook.Column label= {t('description')} value="costDescription"/>
              <Workbook.Column label= {t('status')}value="costStatus"/>
              <Workbook.Column label= {t('managerNameAndSurname')}value="managerNameAndSurname"/>
              <Workbook.Column label= {t('managerApprovalDate')}value="managerApprovalDate"/>
              <Workbook.Column label="Muhasebe Onay Tarihi" value="accountingApprovalDate"/>
               {this.writeCostCenterColumns()}
              <Workbook.Column label= {t('transactionDate')} value="costCreatedDate"/>
          </Workbook.Sheet>
          </Workbook>
              {
                  showAllPdfDownload &&
                  <span>
            &nbsp;
                      <button title={t('downloadAllPDF')} type="button" id={"costListCostDownloadButton-"} onClick={() => { this.allPdfDownloadButton() }} className="btn btn-primary btn-fill btn-wd actionBtn">
              <span className="btn-label"><i className="fa fa-download"></i></span>
            </button>
          </span>

              }

          </th>;

      return (
      <div className="content">
          {
              /*
                Cost Image Popup
              */
          }

          <CostImagePopup t={t} closeButton={() => {
              this.setState({
                  img: {
                      show: false,
                      src: ""
                  }
              })
          }} show={this.state.img.show} src={this.state.img.src}/>
              <Modal show={this.state.isVisibleModalSumiagro}>
              <Modal.Header closeButton onHide={() => {
                  context.closeAction()
              }}>
                  <Modal.Title id="contained-modal-title">{t("costDetail")} / <span
                      className="costForUsername">{user.employeeName}</span></Modal.Title>
              </Modal.Header>
              <Modal.Body>
                  <table className="table table-hover table-bordered">
                      <tbody>
                      <tr>
                          <td>{t("costFormType")}</td>
                          <td><h6>{cost.formType === "applicationSumiagro" ? "Application" : "Settlement"}</h6></td>
                      </tr>
                      <tr>
                          <td>{t("costDate")}</td>
                          <td><span>{cost.costDate}</span></td>
                      </tr>
                      <tr>
                          <td>{t("invoiceNo")}</td>
                          <td><span>{cost.invoiceNo}</span></td>
                      </tr>
                      <tr>
                          <td>{t("costType")}</td>
                          <td><span>{cost.costType}</span></td>
                      </tr>

                {
                  cost.formType === "settlementSumiagro" ? (
                    <>
                      <tr>
                        <td>{t("preApprovedBudget")}</td>
                        <td><span>{cost.costAmount}</span></td>
                      </tr>
                      <tr>
                        <td>{t("actualExpenditure")}</td>
                        <td><span>{cost.costAmount}</span></td>
                      </tr>
                    </>
                  ) : (
                      <tr>
                          <td>{t("costAmount")}</td>
                          <td><span>{cost.costAmount}</span></td>
                      </tr>
                  )
                }
                <tr>
                      <td>{t("company")}</td>
                      <td><span>{cost.companyName}</span></td>
                </tr>
                <tr>
                      <td>{t("place")}</td>
                      <td><span>{cost.placeName}</span></td>
                </tr>
                <tr>
                      <td>{t("guests")}</td>
                      <td><span>{cost.guestName}</span></td>
                </tr>
                <tr>
                      <td>{t("guestNumber")}</td>
                      <td><span>{cost.guestNumber}</span></td>
                </tr>
                <tr>
                      <td>{t("staff")}</td>
                      <td><span>{cost.staffName}</span></td>
                </tr>
                <tr>
                      <td>{t("staffNumber")}</td>
                      <td><span>{cost.staffNumber}</span></td>
               </tr>
                <tr>
                      <td>{t("otherParticipants")}</td>
                      <td><span>{cost.otherParticipant}</span></td>
                </tr>
                <tr>
                      <td>{t("otherParticipantNumber")}</td>
                      <td><span>{cost.otherParticipantNumber}</span></td>
                </tr>
                      <tr>
                          <td>{t("currencyUnit")}</td>
                          <td><span>{cost.moneyType}</span></td>
                      </tr>
                      <tr>
                          <td>{t("paymentType")}</td>
                          <td><span>{cost.paymentType}</span></td>
                      </tr>
                      {cost.costCategory ?
                       <tr>
                          <td>{t("costCategory")}</td>
                          <td><span>{cost.costCategory}</span></td>
                       </tr> :null
                      }
                      {
                          cost.kdvOrani
                              ?
                              <tr>
                                  <td>{t("vatRate")}</td>
                                  <td><span>{cost.kdvOrani}</span></td>
                              </tr>
                              :
                              null
                      }
                      <tr>
                          <td>{t("supplierName")}</td>
                          <td><span>{cost.supplierName}</span></td>
                      </tr>
                      <tr>
                          <td>{t("description")}</td>
                          <td><span>{cost.costDescription}</span></td>
                      </tr>
                      <tr>
                          <td>{t("photos")}</td>
                          <td>
                              <div className="row">
                                  {
                                      cost.costPhotos.length > 0
                                          ?
                                          cost.costPhotos.map((d, k) => {
                                              return <CostPhotoListComponent t={t} costImagePopupShow={(src) => {
                                                  this.costImagePopupShow(src)
                                              }} photo={d} key={k}/>
                                          })
                                          :
                                          <h6 className="title" style={{paddingLeft: "10px"}}>{t("photoIsNotUploadded")}</h6>
                                  }
                              </div>
                          </td>
                      </tr>
                      {
                          cost.status == "cancel"
                              ?
                              <tr>
                                  <td>{t("reasonForCancellation")}:</td>
                                  <td><span className="cancelText">{cost.costCancelDescription}</span></td>
                              </tr>
                              :
                              null
                      }
                      </tbody>
                  </table>
              </Modal.Body>
              <Modal.Footer>
                  <div className="row">
                      <div className="col-md-2">
                         { cost.revisions && cost.revisions.length  > 0
                            ?
                          <Button className="btn btn-warning btn-fill btn-wd" onClick={() => {
                              this.setState({
                                  revisionsModal: true,
                                  isVisibleModalSumiagro: false
                              })
                          }}>{t("revisions")}</Button>
                          : null
                        }
                      </div>
                  </div>
              </Modal.Footer>
          </Modal>

          <Modal show={this.state.isVisibleModal}>
              <Modal.Header closeButton onHide={() => {
                  context.closeAction()
              }}>
                  <Modal.Title id="contained-modal-title">{t('costDetail')} / <span
                      className="costForUsername">{user.employeeName}</span></Modal.Title>
              </Modal.Header>
              <Modal.Body>
                  <table className="table table-hover table-bordered">
                      <tbody>
                      <tr>
                          <td>{t('costDate')}</td>
                          <td><span>{moment(cost.costDate).format('DD/MM/YYYY')}</span></td>
                      </tr>
                      <tr>
                          <td>{t('invoiceNo')}</td>
                          <td><span>{cost.invoiceNo}</span></td>
                      </tr>
                      <tr>
                          <td>{t('costType')}</td>
                          <td><span>{cost.costType}</span></td>
                      </tr>
                      <tr>
                          <td>{t('costAmount')}</td>
                          <td><span>{cost.costAmount}</span></td>
                      </tr>
                      <tr>
                          <td>{t('currencyUnit')}</td>
                          <td><span>{cost.moneyType}</span></td>
                      </tr>
                      <tr>
                          <td>{t('paymentType')}</td>
                          <td><span>{cost.paymentType}</span></td>
                      </tr>
                      {cost.costCategory ?
                       <tr>
                          <td>{t('costCategory')}</td>
                          <td><span>{cost.costCategory}</span></td>
                       </tr> :null
                      }
                      {
                          cost.kdvOrani
                              ?
                              <tr>
                                  <td>{t('vatRate')}</td>
                                  <td><span>{cost.kdvOrani}</span></td>
                              </tr>
                              :
                              null
                      }
                      <tr>
                          <td>{t('supplierName')}</td>
                          <td><span>{cost.supplierName}</span></td>
                      </tr>
                      <tr>
                          <td>{t('description')}</td>
                          <td><span>{cost.costDescription}</span></td>
                      </tr>
                      <tr>
                          <td>{t('photos')}</td>
                          <td>
                              <div className="row">
                                  {
                                      cost.costPhotos.length > 0
                                          ?
                                          cost.costPhotos.map((d, k) => {
                                              return <CostPhotoListComponent t={t} costImagePopupShow={(src) => {
                                                  this.costImagePopupShow(src)
                                              }} photo={d} key={k}/>
                                          })
                                          :
                                          <h6 className="title" style={{paddingLeft: "10px"}}>{t('photoIsNotUploadded')}</h6>
                                  }
                              </div>
                          </td>
                      </tr>
                      {
                          cost.status == "cancel"
                              ?
                              <tr>
                                  <td>{t('reasonForCancellation')}:</td>
                                  <td><span className="cancelText">{cost.costCancelDescription}</span></td>
                              </tr>
                              :
                              null
                      }
                      </tbody>
                  </table>
              </Modal.Body>
              <Modal.Footer>
                  <div className="row">
                      <div className="col-md-2">
                         { cost.revisions && cost.revisions.length  > 0
                            ?
                          <Button className="btn btn-warning btn-fill btn-wd" onClick={() => {
                              this.setState({
                                  revisionsModal: true,
                                  isVisibleModal: false
                              })
                          }}>{t('revisions')}</Button>
                          : null
                        }
                      </div>
                  </div>
              </Modal.Footer>
          </Modal>
          {
              /*
                Revize Modal
              */
          }
          <Modal show={this.state.revisionsModal}>
              <Modal.Header closeButton onHide={() => {
                  this.setState({
                      revisionsModal: false
                  })
              }}>
                  <Modal.Title id="contained-modal-title">{t('revisions')} / <span
                      className="costForUsername" dangerouslySetInnerHTML={{__html: t('totalRevision',{length: cost.revisions ? cost.revisions.length : null})}}></span></Modal.Title>
              </Modal.Header>
              <Modal.Body>
                  <PanelGroup>
                      {
                          cost.revisions.length > 0
                              ?
                              cost.revisions.map((fields, key) => {
                                  return (
                                      <Panel key={key} collapsible header={fields.date} eventKey={key}>
                                          <table className="table table-hover table-bordered">
                                              <tbody>
                                              {
                                                  Object.keys(fields.fields).length > 0
                                                      ?
                                                      mapForObject(fields.fields, (data, index, key2) => {
                                                          var nextData = [];
                                                          var incrementKey = key + 1;
                                                          while (incrementKey < cost.revisions.length) {
                                                              nextData = mapForObject(cost.revisions[incrementKey].fields, index);
                                                              if (typeof nextData != "object")
                                                                  break;
                                                              incrementKey++;
                                                          }
                                                          if (typeof nextData === "object")
                                                              nextData = cost[index];
                                                          return (
                                                              <tr key={key2}>
                                                                  <td>{t(filterValue.costFields[index])}</td>
                                                                  <td><strong
                                                                      className="darkred">{data}</strong> / <strong
                                                                      className="green">{nextData}</strong></td>
                                                              </tr>
                                                          )
                                                      })
                                                      :
                                                      <tr>
                                                          <td>{t('notUpdatedData')}</td>
                                                      </tr>
                                              }
                                              </tbody>
                                          </table>
                                      </Panel>

                                  )
                              })
                              :
                              null
                      }
                  </PanelGroup>
              </Modal.Body>
              <Modal.Footer style={{textAlign: "left"}}>
                  <button type="button" onClick={() => this.closeRevisionsModal()} className="btn btn-wd btn-default"><span className="btn-label"><i className="fa fa-arrow-left"></i></span>{t('back')}
                  </button>
              </Modal.Footer>
          </Modal>
          {
              /*
                İşlem Modal
              */
          }
          <Modal show={this.state.transactionModal}>
              <Modal.Header closeButton onHide={() => {
                  this.setState({
                      transactionModal: false
                  })
              }}>
                  <Modal.Title id="contained-modal-title">{t('transactions')}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                  <PanelGroup>
                      {
                          cost.transactions
                              ?
                              cost.transactions.map((fields, key) => {
                                  return (
                                      <Panel style={{padding: "10px 10px 0px 10px"}}
                                             key={key} collapsible
                                             header={fields.transactionDate + " - " + fields.employeeName}
                                             eventKey={key}>
                                          <p className="p">
                                              <strong className="employeeName">{fields.employeeName}, </strong>
                                              <span dangerouslySetInnerHTML={{
                                                __html: t('approvedRejectedDate',
                                                {
                                                    date:fields.transactionDate,
                                                    time:fields.transactionTime,
                                                    transactionType: fields.transactionType == 1 ? t('approvedTransactions') : t('rejectedTransactions')
                                                })}}></span>
                                          </p>
                                      </Panel>
                                  )
                              })
                              :
                              null
                      }
                  </PanelGroup>
              </Modal.Body>
          </Modal>
          <div className="container-fluid">
              <div className="row">
                  <div className="card costList">
                      <div className="header" style={{paddingTop: "12px"}}>
                          <h4 className="title">{t('filterReport')}</h4>
                      </div>
                      <div className="content">
                          <div className="row">
                                <div className="col-md-1 reportFilterInput reportSwitchToggle">
                                  <Switch
                                    onColor="#eb5e28"
                                    offColor="lightgrey"
                                    className="switch"
                                    checked={this.state.switchStatus}
                                    onChange={(checked) => { this.switchOnChange(checked); }}
                                />
                                </div>
                              <div className="col-md-3 reportFilterInput">
                                  <select ref="employees" onChange={(e) => {
                                      this.setFilterAction({
                                          status: this.refs.costStatusOption.value,
                                          month: this.state.switchStatus ? null : this.refs.month.value,
                                          year: this.state.switchStatus ? null :  this.refs.year.value,
                                          employee:e.target.value
                                      })
                                  }} className="form-control input-sm border-input filterSelect">

                                      {employeeList && employeeList.length > 0 ? <option value="-1" selected >{t('selectPersonnel')}</option> : null}
                                      <option key ="0" value="0">{`${employeeInfo.employeeName} / ${employeeInfo.unitName}`}</option>
                                      {
                                        employeeList.map((e) => {
                                            if(e.employeeName != `${employeeInfo.employeeName} / ${employeeInfo.unitName} - ${employeeInfo.employmentID} `){
                                            return  <option key={e._id} value={e._id}>{e.employeeName}</option>
                                            }
                                        })
                                     }
                                  </select>
                              </div>

                              <div className="col-md-2 reportFilterInput" style={{
                                  paddingTop:"26px"
                              }}>
                                  <select ref="costStatusOption" onChange={(e) => {
                                      this.setFilterAction({
                                          status: e.target.value,
                                          month: this.state.switchStatus ? null : this.refs.month.value,
                                          year: this.state.switchStatus ? null :  this.refs.year.value ,
                                          employee:this.refs.employees.value,
                                      })
                                  }} defaultValue={this.props.filter.status}
                                          className="form-control input-sm border-input filterSelect">
                                      <option value="-1">{t('selectStatus')}</option>
                                      <option value="manager">{t('awaitingApproval')}</option>
                                      <option value="approved">{t('approvedCosts')}</option>
                                      <option value="cancel">{t('rejects')}</option>
                                  </select>
                              </div>

                                {this.state.switchStatus ?
                                <>
                                 <div className="col-md-2 startDate" >
                                    <label>
                                          <span className="required-field">
                                                *
                                          </span>
                                        {' '}
                                        {t('startDate')}
                                    </label>
                                     <input id="startDate" type="date" name="startDate" ref="startDate" required
                                       className="form-control border-input"
                                       onChange={(e) => this.handleMultiDateChange(e) }
                                     />
                                     </div>
                                    <div className="col-md-2 endDate">
                                    <label>
                                          <span className="required-field">
                                                *
                                          </span>
                                        {' '}
                                        {t('endDate')}
                                    </label>
                                    <input id="endDate" type="date" name="endDate" ref="endDate" required
                                     className="form-control border-input"
                                     onChange={(e) => this.handleMultiDateChange(e) }/>
                                    </div>
                                    <div className="col-md-2 reportFilterInput reportFilterInputButton">
                                    <button  id="bringButton" onClick={this.handleBringButtonClick}
                                     className="btn btn-fill btn-success"> {t('bring')} </button>
                                    </div>
                                </>
                                :

                                <>
                                    <div className="col-md-2 reportFilterInput month">
                                    <select ref="month" onChange={(e) => {
                                        this.setFilterAction({
                                            status: this.refs.costStatusOption.value,
                                            month: e.target.value,
                                            year:this.refs.year.value,
                                            employee:this.refs.employees.value
                                        })
                                    }} defaultValue={this.props.filter.month} className="form-control input-sm border-input filterSelect">
                                        <option value="-1">{t('selectMonth')}</option>
                                        <option value="01">{t('jan')}</option>
                                        <option value="02">{t('feb')}</option>
                                        <option value="03">{t('mar')}</option>
                                        <option value="04">{t('apr')}</option>
                                        <option value="05">{t('may')}</option>
                                        <option value="06">{t('jun')}</option>
                                        <option value="07">{t('jul')}</option>
                                        <option value="08">{t('aug')}</option>
                                        <option value="09">{t('sep')}</option>
                                        <option value="10">{t('oct')}</option>
                                        <option value="11">{t('nov')}</option>
                                        <option value="12">{t('dec')}</option>
                                    </select>
                                     </div>
                                    <div className="col-md-2 reportFilterInput">
                                        <select ref="year" onChange={(e) => {
                                            this.setFilterAction({
                                                status: this.refs.costStatusOption.value,
                                                month: this.refs.month.value,
                                                year:e.target.value,
                                                employee:this.refs.employees.value
                                            })
                                        }} defaultValue={this.props.filter.year} className="form-control input-sm border-input filterSelect">
                                            <option value="-1">{t('selectYear')}</option>
                                            {year}
                                        </select>
                                    </div>
                                </>
                                }

                          </div>
                      </div>
                  </div>
                  <div className="card">
                      <div className="content">
                          {
                              this.state.loading ?
                                  <LoadingComponent type={"bars"} color={'#3298e9'} name={t('reportInfoMessage')}/>
                                  :null
                          }
                          <div className="content table-responsive table-full-width">
                              <table className="table table-striped">
                                  <thead>
                                  <tr>
                                      <th>{t('employee')}</th>
                                      <th>{t('invoice')}</th>
                                      <th>{t('costType')}</th>
                                      <th>{t('costAmount')}</th>
                                      <th>{t('costDate')}</th>
                                      <th>{t('creationDate')}</th>
                                      <th></th>
                                      {
                                          showKdvOrani ?

                                              workBookWithKdvOrani
                                              :
                                              workBookVariable
                                      }
                                  </tr>
                                  </thead>
                                  <tbody id="reportPageCostList">
                                  {
                                      costLists.length > 0
                                          ?
                                          costLists.slice(start, finish).map((data, key) => {
                                              return <ReportListComponent t={t} transactionsButton={(user, cost) => {
                                                this.setState({
                                                      transactionModal: true,
                                                      detail: {user: user, cost: cost}
                                                  })
                                              }} infoButton={(user, cost) => {
                                                  context.infoButton(user, cost)
                                              }} data={data} key={key}
                                              pdfDownloadButton={() => { this.pdfDownloadButton(data) }}
                                              />
                                          })
                                          :
                                          null
                                  }
                                  </tbody>
                              </table>
                          </div>
                      </div>
                  </div>
                  <div className="card">
                      <div className="content">
                          <PaginationComponent t={t} parent={this} endPageNumber={this.state.endPageNumber}
                                               startPageNumber={this.state.startPageNumber}
                                               pageNumberToShow={this.state.pageNumberToShow}
                                               activePage={this.state.activePage} numberOfPage={this.state.numberOfPage}
                                               totalPage={totalPage} data={costLists}/>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    )
  }
}

export default connectTo(() => (
  ({
    reports: { data, loading, filter },
    login: { employeeInfo },
    employees: { employeeList },
  }) => ({
    accessToken: employeeInfo.accessToken,
    employeeList: employeeInfo.permission.accountingPage === "true" ?  employeeList.employeeListAccountingApproval :  employeeList.employeeListManagerApproval,
    costLists: data,
    filter,
    employeeInfo,
    loading,
  })
), {
  getReportingRequest,
  pdfDownloadReport,
    setFilter
}, ReportsComponent);
